var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDuplicateOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 4.66667V10C5.33341 10.3536 5.47389 10.6928 5.72394 10.9428C5.97399 11.1929 6.31313 11.3333 6.66675 11.3333H10.6667M5.33341 4.66667V3.33333C5.33341 2.97971 5.47389 2.64057 5.72394 2.39052C5.97399 2.14048 6.31313 2 6.66675 2H9.72408C9.90088 2.00004 10.0704 2.0703 10.1954 2.19533L13.1381 5.138C13.2631 5.263 13.3334 5.43254 13.3334 5.60933V10C13.3334 10.3536 13.1929 10.6928 12.9429 10.9428C12.6928 11.1929 12.3537 11.3333 12.0001 11.3333H10.6667M5.33341 4.66667H4.00008C3.64646 4.66667 3.30732 4.80714 3.05727 5.05719C2.80722 5.30724 2.66675 5.64638 2.66675 6V12.6667C2.66675 13.0203 2.80722 13.3594 3.05727 13.6095C3.30732 13.8595 3.64646 14 4.00008 14H9.33341C9.68704 14 10.0262 13.8595 10.2762 13.6095C10.5263 13.3594 10.6667 13.0203 10.6667 12.6667V11.3333",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDuplicateOutline);
export default __webpack_public_path__ + "static/media/DocumentDuplicateOutline.c25dd20a3b4ede01a29b3037d569c860.svg";
export { ForwardRef as ReactComponent };